import Vue from 'vue';
import $ from 'jquery';
import { mapGetters } from 'vuex';
import DataUpload from 'src/components/project/create/DataUpload.vue';
import ProgressIndicator from 'src/components/widgets/ProgressIndicator.vue';
import Project from 'src/api/project';
import FormatUtils from 'src/utils/formatters';
import { CLEAR_REQUEST_ERRORS } from 'src/store/types';
export default Vue.extend({
    components: { DataUpload, ProgressIndicator },
    data() {
        return {
            dataFile: null,
            dropdowns: null,
            isLoading: false,
            isMounted: false,
            isFileSelected: false,
            noTextFieldError: false,
            incompatibleSchemaError: false,
            step: 1,
            unmappedProjectFields: [],
        };
    },
    computed: {
        ...mapGetters([
            'currentProject', 'plan', 'subscription'
        ]),
        canGoBack() {
            return this.step > 1 || this.isFileSelected;
        },
        canGoNext() {
            return this.step > 1 || this.dataFile !== null;
        },
        fileRowLimit() {
            return Math.min(500000, this.subscription.projectRowLimit ?? Infinity);
        },
        fileColumnLimit() {
            return Math.min(500, this.subscription.projectColumnLimit ?? Infinity);
        },
        numResponses() {
            if (this.dataFile) {
                return this.$refs.dataUpload.numResponses;
            }
            return 0;
        },
        projectId() {
            return this.$route.params.projectId;
        },
        // List of project text fields by name
        projectTextFields() {
            let textFields = [];
            this.currentProject.schema.forEach((f) => {
                if (f.type === 1) {
                    textFields.push(f.name);
                }
            });
            return textFields;
        },
        schema() {
            if (this.dataFile) {
                return this.dataFile.schema;
            }
            return [];
        },
        showDataUnits() {
            return this.plan === 'data-unit-plan';
        },
        mappableSchema() {
            return this.currentProject.schema.filter(s => s.name !== 'NPS Category');
        },
    },
    watch: {
        dataFile() {
            this.$nextTick(() => {
                this.dropdowns = $(this.$el).find('.mapping-table .ui.dropdown').dropdown();
                let schema = this.schema;
                const dropdownOptions = this.mappableSchema.map(col => col.name.trim());
                this.dropdowns.each(function (i) {
                    const newIdx = dropdownOptions.indexOf(schema[i].name.trim());
                    $(this).dropdown('set selected', newIdx.toString());
                });
                this.checkUnmappedProjectFields();
            });
        }
    },
    mounted() {
        this.isMounted = true; // refs available
    },
    methods: {
        number: FormatUtils.number,
        // Check current mappings to determine if a text column is selected
        checkMappings() {
            let mappings = this.getMappings();
            let hasMappedText = false;
            for (let v of Object.values(mappings)) {
                if (v !== -1 && this.currentProject.schema[v].type === 1) {
                    hasMappedText = true;
                    break;
                }
            }
            return hasMappedText;
        },
        // Return list of current mappings.
        getMappings() {
            let mappings = {};
            this.dropdowns.each((i, el) => {
                mappings[this.schema[i].name] = parseInt($(el).dropdown('get value'), 10);
            });
            return mappings;
        },
        checkUnmappedProjectFields() {
            if (!this.dropdowns)
                return [];
            const usedIdxes = Object.values(this.getMappings()).filter(val => val !== -1);
            this.unmappedProjectFields = this.mappableSchema.filter(s => !usedIdxes.includes(s.index)).map(s => s.name);
        },
        // Trigger the indexing of data by the server.
        indexData() {
            this.isLoading = true;
            this.incompatibleSchemaError = false;
            let dataFileId = this.dataFile.id;
            let mappings = this.getMappings();
            // Start indexing
            Project.indexDataFiles(this.projectId, [dataFileId], mappings).then(() => {
                this.dataAdded = true;
                this.$analytics.track.project.addData(this.$refs.dataUpload.fileSize, this.numResponses);
                this.$router.push({ name: 'project-details', params: { projectId: this.projectId } });
            }).catch((error) => {
                this.$store.dispatch(CLEAR_REQUEST_ERRORS); // use custom instead of global error handling
                if (error.body['non_field_errors']?.[0]?.toLowerCase().includes("incompatible schema")) {
                    let nonFieldErrors = error.body['non_field_errors'][0];
                    this.incompatibleSchemaError = nonFieldErrors;
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        goBack() {
            this.noTextFieldError = false;
            if (this.step === 1) {
                // Reset data upload state
                this.$refs.dataUpload.clearUpload();
            }
            else {
                this.step -= 1;
            }
        },
        goNext() {
            if (this.step === 2) {
                if (!this.checkMappings()) {
                    this.noTextFieldError = true;
                    return;
                }
                this.indexData();
                return;
            }
            this.noTextFieldError = false;
            this.step += 1;
        },
        onFileCleared() {
            this.dataFile = null;
            this.isFileSelected = false;
        },
        onFileReady(dataFile) {
            this.dataFile = dataFile;
        },
        onObjectSelected() {
            this.isFileSelected = true;
        }
    }
});
